import { render } from "./ReferralConsultationSectionDetails.vue?vue&type=template&id=48bd20b3&scoped=true"
import script from "./ReferralConsultationSectionDetails.vue?vue&type=script&lang=js"
export * from "./ReferralConsultationSectionDetails.vue?vue&type=script&lang=js"

import "./ReferralConsultationSectionDetails.vue?vue&type=style&index=0&id=48bd20b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bd20b3"],['__file',"src/components/ReferralConsultationSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48bd20b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48bd20b3', __exports__)) {
    api.reload('48bd20b3', __exports__)
  }
  
  module.hot.accept("./ReferralConsultationSectionDetails.vue?vue&type=template&id=48bd20b3&scoped=true", () => {
    api.rerender('48bd20b3', render)
  })

}


export default __exports__